import { useCallback, useEffect, useState } from "react";
import { UserPlus, KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

function AddOwner({ onDone }) {
  const { t } = useI18n();
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const add = async () => {
    try { await api.post("/owner/users", f); toast.success(t("o.owner_added", { email: f.email })); setF({ name: "", email: "", password: "" }); onDone(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="rounded-2xl bg-white border border-slate-200 p-6 space-y-3" data-testid="add-owner-form">
      <p className="font-semibold flex items-center gap-2"><UserPlus className="h-4 w-4 text-teal-600" />{t("o.add_owner_t")}</p>
      <Input placeholder={t("o.name")} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="owner-new-name" />
      <Input placeholder={t("o.email")} value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="owner-new-email" />
      <Input placeholder={t("o.temp_pw8")} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="owner-new-password" />
      <Button className="bg-teal-600 hover:bg-teal-700" onClick={add} data-testid="owner-add-btn">{t("o.add_owner")}</Button>
      <p className="text-xs text-slate-500">{t("o.add_owner_hint")}</p>
    </div>
  );
}

function ChangePassword() {
  const { t } = useI18n();
  const [f, setF] = useState({ current_password: "", new_password: "" });
  const save = async () => {
    try { await api.post("/auth/change-password", f); toast.success(t("o.pw_updated")); setF({ current_password: "", new_password: "" }); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="rounded-2xl bg-white border border-slate-200 p-6 space-y-3" data-testid="change-password-form">
      <p className="font-semibold flex items-center gap-2"><KeyRound className="h-4 w-4 text-teal-600" />{t("o.change_pw")}</p>
      <Input type="password" placeholder={t("o.cur_pw")} value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} data-testid="cp-current" />
      <Input type="password" placeholder={t("o.new_pw")} value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} data-testid="cp-new" />
      <Button onClick={save} data-testid="cp-save-btn">{t("o.update_pw")}</Button>
    </div>
  );
}

export default function OwnerTeam() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/owner/users").then((r) => setItems(r.data)), []);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="grid lg:grid-cols-3 gap-6" data-testid="owner-team">
      <div className="rounded-2xl bg-white border border-slate-200 p-6">
        <p className="font-semibold mb-3">{t("o.owners")}</p>
        <div className="space-y-2">{items.map((o) => (
          <div key={o.id} className="text-sm border-b last:border-0 pb-2" data-testid="owner-user-row"><p className="font-medium">{o.name}</p><p className="text-slate-500 text-xs">{o.email} · {fmtDate(o.created_at)}</p></div>
        ))}</div>
      </div>
      <AddOwner onDone={load} />
      <ChangePassword />
    </div>
  );
}
